export const OrientationBadge = ({badge, label, maxScore}) => {
    return (
        <div className="col-12 col-lg-6">
            <div className="d-flex align-items-center flex-column mb-2 mb-lg-4">
                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                    <span className="fw-semibold fs-7">{label}</span>
                    <span className="fw-bold fs-7">
                        {badge.score} / {maxScore}
                    </span>
                </div>
                <div className="h-8px rounded mx-3 w-100 bg-secondary mb-3">
                    <div className={`rounded h-8px ${badge.color}`} style={{width: `${badge.width}%`}}></div>
                </div>
            </div>
        </div>
    )
}
